/* derw-header.js, 3 Oct 2026. Small header touches: search hint, current-menu underline, discount progress bar. */
(function(){
  function run(){
    var inp=document.querySelector('.header .search-bar__input');
    if(inp) inp.placeholder='Search products, brands or SKU';
    var path=location.pathname;
    document.querySelectorAll('.nav-bar__item > .nav-bar__link').forEach(function(a){
      var h=a.getAttribute('href')||'';
      if(h && h!=='/' && h.indexOf('#')<0 && h.split('?')[0]===path) a.classList.add('derw-current');
    });
    var inner=document.querySelector('.derw-hdrbar__inner'), txt=document.querySelector('[data-derw-hdrbar-text]');
    if(!inner||!txt) return;
    var bar=document.createElement('span'); bar.className='derw-hdrbar__bar'; bar.setAttribute('aria-hidden','true'); bar.innerHTML='<i></i>';
    txt.insertAdjacentElement('afterend',bar);
    var tiers={5:[0,10],10:[10,20],15:[20,100],20:[100,200]};
    function paint(){
      var t=txt.textContent||'', m=t.match(/(\d+)\s*units?/i), pct=t.match(/(\d+)%/), p=100;
      if(m&&pct&&tiers[+pct[1]]){var r=tiers[+pct[1]], left=+m[1]; p=Math.max(0,Math.min(100,((r[1]-r[0]-left)/(r[1]-r[0]))*100));}
      bar.style.setProperty('--p',p+'%');
    }
    paint(); new MutationObserver(paint).observe(txt,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
